import axios from "axios";
import {setRequestManagerAction} from "../redux/actions/setRequestManagerAction";
import appStore from "../app-store"
import AppSession from "./session";
import AppConfig from "../app-config";

// Setup interceptors
let requestData = appStore.getState().request;
axios.interceptors.request.use(config => {
    const {dispatch} = appStore;
    requestData = {...appStore.getState().request, detail: config};
    dispatch(
        setRequestManagerAction(requestData)
    );
    return config;
}, error => {
    const {dispatch} = appStore;
    requestData = {...appStore.getState().request, detail: error};
    dispatch(
        setRequestManagerAction(requestData)
    );
    return Promise.reject(error);
});
axios.interceptors.response.use(response => {
    const {dispatch} = appStore;
    requestData = {...appStore.getState().request, detail: response};
    dispatch(
        setRequestManagerAction(requestData)
    );
    return response;
}, error => {
    const {dispatch} = appStore;
    requestData = {...appStore.getState().request, detail: error};
    dispatch(
        setRequestManagerAction(requestData)
    );
    return Promise.reject(error);
});

// Request Services
export default class Request {
    constructor() {
        this.config = {
            withCredentials: false,
            headers: {
                'X-ID': AppSession.auth() ? AppSession.auth().userData.user_id : '',
                'X-Provider': 'Vicocons',
                'X-Token': AppSession.auth() ? AppSession.auth().token : ''
            }
        };
    };

    fetchData(method, url, params) {
        switch (method) {
            case 'GET':
                return axios.get(url, this.config).then(resp => resp.data);
            case 'POST':
                return axios.post(url, params, this.config).then(resp => resp.data);
            case 'PUT':
                return axios.put(url, params, this.config).then(resp => resp.data);
            case 'DELETE':
                return axios.delete(url, {headers: {...this.config.headers}, data: params}).then(resp => resp.data);
            default:
                break;
        }

    }


    get(endPoint, params, successCallback = null, errorCallback = null, failureCallback = null, api = AppConfig.BASE_API_URL) {
        let self = this;
        let locale = AppSession.auth().locale;
        let queryString = `?locale=${locale}&`;
        if (params !== null) {
            for (let i = 0; i < params.length; i++) {
                queryString = `${queryString}${params[i].name}=${params[i].value}&`
            }
        }
        const url = `${api}/${endPoint}${queryString}`;
        return dispatch => {
            dispatch(
                setRequestManagerAction({
                    ...appStore.getState().request,
                    code: '',
                    isError: false,
                    isLoading: true,
                    message: '',
                    msgCode: ''
                })
            );
            self.fetchData('GET', url, params).then(raw_data => {
                const code = raw_data.Code || '';
                const message = raw_data.Message || '';
                const data = raw_data.Data || '';
                const msg_code = raw_data.MsgCode;
                let reqData = {...appStore.getState().request, isLoading: false, code: code, message: message, msgCode: msg_code};
                if (code !== 'Executed_OK' || message !== '') {
                    reqData = {...reqData, isError: true}
                    if(typeof failureCallback ==="function"){
                        dispatch(failureCallback(raw_data))
                    }
                } else {
                    if (successCallback != null) {
                        dispatch(successCallback(data));
                    }
                    reqData = {...reqData, isError: false}
                }
                dispatch(
                    setRequestManagerAction(reqData)
                );
            }).catch(error => {
                if (errorCallback != null) {
                    dispatch(errorCallback(error));
                }
                dispatch(
                    setRequestManagerAction({...appStore.getState().request, isLoading: false, isError: false, message: error.toString(), msgCode: ''})
                );
            });
        }
    }

    post(endPoint, params, data, successCallback, errorCallback, api = AppConfig.BASE_API_URL) {
        let self = this;
        let locale = AppSession.auth().locale;
        let queryString = `?locale=${locale}&`;
        if (params !== null) {
            for (let i = 0; i < params.length; i++) {
                queryString = `${queryString}${params[i].name}=${params[i].value}&`
            }
        }
        const url = `${api}/${endPoint}${queryString}`;
        return dispatch => {
            dispatch(
                setRequestManagerAction({
                    ...appStore.getState().request,
                    code: '',
                    isError: false,
                    isLoading: true,
                    message: '',
                    msgCode: ''
                })
            );
            self.fetchData('POST', url, data).then(raw_data => {
                const code = raw_data.Code || '';
                const message = raw_data.Message || '';
                const data = raw_data.Data || '';
                const msg_code = raw_data.MsgCode;
                let reqData = {...appStore.getState().request, isLoading: false, code: code, message: message ? message : data, msgCode: msg_code};
                //Should use code to know when we need to show success or error message
                if (code !== 'Executed_OK' || message !== '') {
                    reqData = {...reqData, isError: true}
                } else {
                    if (successCallback != null) {
                        dispatch(successCallback(data));
                    }
                    reqData = {...reqData, isError: false}
                }
                dispatch(
                    setRequestManagerAction(reqData)
                );
            }).catch(error => {
                if (errorCallback != null) {
                    dispatch(errorCallback(error));
                }
                dispatch(
                    setRequestManagerAction({...appStore.getState().request, isLoading: false, isError: false, message: error.toString(), msgCode: ''})
                );
            });
        }
    }

    put(endPoint, params, data, successCallback, errorCallback, api = AppConfig.BASE_API_URL, def) {
        let self = this;
        let locale = AppSession.auth().locale;
        let queryString = !def ? `?locale=${locale}&` : '';
        if (params !== null) {
            for (let i = 0; i < params.length; i++) {
                queryString = `${queryString}${params[i].name}=${params[i].value}&`
            }
        }
        const url = `${api}/${endPoint}${queryString}`;
        return dispatch => {
            dispatch(
                setRequestManagerAction({
                    ...appStore.getState().request,
                    code: '',
                    isError: false,
                    isLoading: true,
                    message: '',
                    msgCode: ''
                })
            );
            self.fetchData('PUT', url, data).then(raw_data => {
                const code = raw_data.Code || '';
                const message = raw_data.Message || '';
                const data = raw_data.Data || '';
                const msg_code = raw_data.MsgCode;
                let reqData = {...appStore.getState().request, isLoading: false, code: code, message: message ? message : data, msgCode: msg_code};
                //Should use code to know when we need to show success or error message
                if (code !== 'Executed_OK' || message !== '') {
                    reqData = {...reqData, isError: true}
                } else {
                    if (successCallback != null) {
                        dispatch(successCallback(data));
                    }
                    reqData = {...reqData, isError: false}
                }
                dispatch(
                    setRequestManagerAction(reqData)
                );
            }).catch(error => {
                if (errorCallback != null) {
                    dispatch(errorCallback(error));
                }
                dispatch(
                    setRequestManagerAction({...appStore.getState().request, isLoading: false, isError: false, message: error.toString(), msgCode: ''})
                );
            });
        }
    }

    delete(endPoint, params, data, successCallback, errorCallback) {
        let self = this;
        let locale = AppSession.auth().locale;
        let queryString = `?locale=${locale}&`;
        if (params !== null) {
            for (let i = 0; i < params.length; i++) {
                queryString = `${queryString}${params[i].name}=${params[i].value}&`
            }
        }
        const url = `${AppConfig.BASE_API_URL}/${endPoint}${queryString}`;
        return dispatch => {
            dispatch(
                setRequestManagerAction({
                    ...appStore.getState().request,
                    code: '',
                    isError: false,
                    isLoading: true,
                    message: '',
                    msgCode: ''
                })
            );
            self.fetchData('DELETE', url, data).then(raw_data => {
                const code = raw_data.Code || '';
                const message = raw_data.Message || '';
                const data = raw_data.Data || '';
                const msg_code = raw_data.MsgCode;
                let reqData = {...appStore.getState().request, isLoading: false, code: code, message: message ? message : data, msgCode: msg_code};
                //Should use code to know when we need to show success or error message
                if (code !== 'Executed_OK' || message !== '') {
                    reqData = {...reqData, isError: true}
                } else {
                    if (successCallback != null) {
                        dispatch(successCallback(data));
                    }
                    reqData = {...reqData, isError: false}
                }
                dispatch(
                    setRequestManagerAction(reqData)
                );
            }).catch(error => {
                if (errorCallback != null) {
                    dispatch(errorCallback(error));
                }
                dispatch(
                    setRequestManagerAction({...appStore.getState().request, isLoading: false, isError: false, message: error.toString(), msgCode: ''})
                );
            });
        }
    }

}
